import React, { Component } from 'react';
//import * as PIXI from 'pixi.js';
import"./Invaders.css";

import CRT from '../filters/crt/pixi_CRT.js';


let NEXT_SPRITE_ID = 0;
const PIXI = window.PIXI;

const keyboard = (keyCode) =>
{
  let key = {};
  key.code = keyCode;
  key.isDown = false;
  key.isUp = true;
  key.press = undefined;
  key.release = undefined;
  //The `downHandler`
  key.downHandler = event => {
    if (event.keyCode === key.code) {
      if (key.isUp && key.press) key.press();
      key.isDown = true;
      key.isUp = false;
      event.preventDefault();
    }
  };

  //The `upHandler`
  key.upHandler = event => {
    if (event.keyCode === key.code) {
      if (key.isDown && key.release) key.release();
      key.isDown = false;
      key.isUp = true;
      event.preventDefault();
    }
  };

  //Attach event listeners
  window.addEventListener(
    "keydown", key.downHandler.bind(key), false
  );
  window.addEventListener(
    "keyup", key.upHandler.bind(key), false
  );
  return key;
}


class Explosion extends PIXI.Sprite
{
  //destroy after two seconds
  static TTL = 1000;

  constructor(alien, destroyCallback)
  {
    super(PIXI.utils.TextureCache['boom.png']);
    this.age = 0;
    PIXI.ticker.shared.add(this.update, this);

    this.width = InvadersContainer.INVADER_W;
    this.height = InvadersContainer.INVADER_H;
    this.alien = alien;

    this.x = this.alien.x;
    this.y = this.alien.y;

    this.onDestroy = destroyCallback;
  }

  update()
  {
    this.age += PIXI.ticker.shared.elapsedMS;
    if(this.age > Explosion.TTL / 2)
    {
      this.alpha = 0.5
    }

    if(this.age > Explosion.TTL)
    {
      this.alpha = 0.0;
    }

    if(this.age > Explosion.TTL * 10) //just read alien after a 10 seconds
    {
      this.onDestroy(this.alien);
      this.destroy();
      PIXI.ticker.shared.remove(this.update, this);
    }
  }
}

class Hero extends PIXI.Sprite
{
  static SPEED = 1;
  static STEP = 10;

  constructor(texture, x, y)
  {
    super(texture);
    this.virtualX = x;

    this.x = x;
    this.y = y;
    this.anchor.set(0.5, 1);
    this.direction = 1;

    this.setupKeys();
  }

  setupKeys()
  {
    this.keyLeft = keyboard(37);
    //this.keyLeft.press = () => {console.log("moving")};
    //keyLeft.release = () => this.movingLeft = false;

    this.keyRight = keyboard(39);
    //keyRight.press = () => this.movingRight = true;
    //keyRight.release = () => this.movingRight = false;
  }

  update()
  {
    if(this.keyLeft.isDown)
    {
      this.virtualX -= Hero.SPEED;
      this.x = Math.floor(this.virtualX / Hero.STEP) * Hero.STEP;
      this.direction = -1;
    }
    else if(this.keyRight.isDown)
    {
      this.virtualX += Hero.SPEED;
      this.x = Math.floor(this.virtualX / Hero.STEP) * Hero.STEP;
      this.direction = 1;
    }
    else
    { //Oh, a real AI
      this.virtualX += this.direction * Hero.SPEED;
      this.x = Math.floor(this.virtualX / Hero.STEP) * Hero.STEP;

      if(this.x + this.width / 2 > window.innerWidth - 10)
        this.direction = -1;

      if(this.x < this.width / 2)
        this.direction = 1;
    }
  }
}

class Bullet extends PIXI.Sprite
{
  static BULLET_DELAY = 2000;
  static SPEED = 15;
  static STEP = 15;

  constructor(texture, x, y)
  {
    super(texture);
    NEXT_SPRITE_ID++;
    this.id = NEXT_SPRITE_ID;

    this.x = x;

    this.virtualY = y;
    this.y = y;
  }

  update()
  {
    this.virtualY -= Bullet.SPEED;
    this.y = Math.floor(this.virtualY / Bullet.STEP) * Bullet.STEP;
  }
}

class InvadersContainer extends PIXI.Container
{
  static SPACING_V = 50
  static SPACING_H = 50;
  static INVADER_W = 33;
  static INVADER_H = 33;
  static SPEED = 1;
  static STEP = 20;

  constructor()
  {
    super();
    this.direction = 1;
    this.virtualX = 0;

    this.y = 100;
  }

  //just calculate if x & y is falling in between the space between the invaders
  //or would touch the invader.
  //This does not assume there is an invader there
  wouldHitSomething(x, y)
  {
    //ix - inside x, bullet position inside container
    let ix = x - this.x;
    //px position - x, bullets position as an index (1, 2, 3, ...);
    let px = Math.floor(ix / InvadersContainer.SPACING_H);

    let iy = y - this.y;
    let py = Math.floor(iy / InvadersContainer.SPACING_V);

  //  console.log(x , px * InvadersContainer.SPACING_H + InvadersContainer.INVADER_W,
  //  y , py * InvadersContainer.SPACING_V + InvadersContainer.INVADER_H);

    if(ix < px * InvadersContainer.SPACING_H + InvadersContainer.INVADER_W
    && iy < py * InvadersContainer.SPACING_V + InvadersContainer.INVADER_H)
    {
      return px + "_" + py;
    }
    else {
      return null;
    }
  }


  update()
  {
    this.virtualX += this.direction * InvadersContainer.SPEED;
    this.x = Math.floor(this.virtualX / InvadersContainer.STEP) * InvadersContainer.STEP;

    if(this.x + this.width > window.innerWidth)
      this.direction = -1;

    if(this.x < 0)
      this.direction = 1;
  }
}

class InvadersGame
{
  constructor(canvasContainer)
  {
    this.bullets = {};
    this.canvasContainer = canvasContainer;
    this.renderer = PIXI.autoDetectRenderer(window.innerWidth, canvasContainer.getBoundingClientRect().height, {transparent:true});
    this.canvasContainer.appendChild(this.renderer.view);

    PIXI.loader
    .add('assets/invaders/sprites.json')
  /*  .add('grad1', 'assets/gradients/grad1.png')
    .add('photo', 'assets/photo.png')*/
    .load(() => this.setup());
  }

  setup()
  {
    this.stage = new PIXI.Container();

    /*let backgroundSprite = new PIXI.Sprite(PIXI.loader.resources["grad1"].texture);
    backgroundSprite.width = this.renderer.width;
    backgroundSprite.height = this.renderer.height;
    backgroundSprite.alpha = 0.3;
    this.stage.addChild(backgroundSprite);*/

    this.actionStage = new PIXI.Container();
    this.stage.addChild(this.actionStage);

    this.bgGraphics = new PIXI.Graphics();
    this.bgGraphics.beginFill(0x0, 0);
    this.bgGraphics.drawRect (0, 0, this.renderer.width, this.renderer.height);
    this.bgGraphics.endFill();
    this.actionStage.addChild(this.bgGraphics);
    //this.stage.addChild(this.actionStage);


    this.lastBulletTime = Bullet.BULLET_DELAY;
    this.setupHero();
    this.addAliens();

    /*let photo = new PIXI.Sprite(PIXI.loader.resources["photo"].texture);
    photo.width = window.innerWidth;
    photo.height = window.innerHeight;
    this.stage.addChild(photo);*/
    //this.actionStage.filters =  [CRT];
    this.actionStage.alpha = 0.1;
    PIXI.ticker.shared.add(() => this.render());

    window.addEventListener('resize', (event) => this.resizeStage(event));
  }

  resizeStage(event)
  {
    //this.renderer.view.style.width = window.width;

    this.renderer.view.style.display = "none";
    setTimeout(() => {
      this.renderer.view.style.display = "";
      this.renderer.resize(window.innerWidth, this.renderer.height);
      this.bgGraphics.clear();
      this.bgGraphics.beginFill(0x0, 0);
      this.bgGraphics.drawRect (0, 0, this.renderer.width, this.renderer.height);
      this.bgGraphics.endFill();
    }, 100);
  }

  returnAlien(alien)
  {
    /*let alien = this.addAlien("alien1");
    alien.x = InvadersContainer.SPACING_H * i;
    alien.y = InvadersContainer.SPACING_V * 0;
    alien.tint = 0x8753b1;
    this.aliensContainer.addChild(alien);
    this.aliens[i + "_0"] = alien;*/

    let x = (alien.x / 100) + "";
    let y = (alien.y / 100) + "";
    this.aliensContainer.addChild(alien);
    this.aliens[x + "_" + y] = alien;
  }

  addAlien(name)
  {
    let alien = new PIXI.extras.AnimatedSprite([PIXI.utils.TextureCache[name + "_a.png"],
                                                PIXI.utils.TextureCache[name + "_b.png"]]);
    alien.width = InvadersContainer.INVADER_W;
    alien.height = InvadersContainer.INVADER_H;
    alien.animationSpeed = 0.05;
    alien.play();
    this.actionStage.addChild(alien);
    return alien;
  }


  addAliens()
  {
    this.aliens = {};

    this.aliensContainer = new InvadersContainer();
    this.actionStage.addChild(this.aliensContainer);

    let numCols = Math.min(10,Math.floor(this.renderer.width / InvadersContainer.SPACING_H) - 4 );


    for(let i = 0; i < numCols; i++)
    {
      let alien = this.addAlien("alien1");
      alien.x = InvadersContainer.SPACING_H * i;
      alien.y = InvadersContainer.SPACING_V * 0;
      alien.tint = 0x8753b1;
      this.aliensContainer.addChild(alien);
      this.aliens[i + "_0"] = alien;
    }

    for(let i = 0; i < numCols; i++)
    {
      let alien = this.addAlien("alien2");
      alien.x = InvadersContainer.SPACING_H * i;
      alien.y = InvadersContainer.SPACING_V * 1;
      alien.tint = 0x48a6f1;
      this.aliensContainer.addChild(alien);
      this.aliens[i + "_1"] = alien;
    }

    for(let i = 0; i < numCols; i++)
    {
      let alien = this.addAlien("alien3");
      alien.x = InvadersContainer.SPACING_H * i;
      alien.y = InvadersContainer.SPACING_V * 2;
      alien.tint = 0x6ccb65;
      this.aliensContainer.addChild(alien);
      this.aliens[i + "_2"] = alien;
    }

    for(let i = 0; i < numCols; i++)
    {
      let alien = this.addAlien("alien1");
      alien.x = InvadersContainer.SPACING_H * i;
      alien.y = InvadersContainer.SPACING_V * 3;
      alien.tint = 0xeef000;
      this.aliensContainer.addChild(alien);
      this.aliens[i + "_3"] = alien;
    }
  }

  addBullet()
  {
      let bullet = new Bullet(PIXI.utils.TextureCache["bullet.png"], this.hero.x, this.hero.y - this.hero.height);
      bullet.anchor.x = 0.5;
      this.actionStage.addChild(bullet);
      this.bullets[bullet.id] = bullet;
  }

  setupHero()
  {
    //this.hero = new PIXI.Sprite(PIXI.loader.resources["hero"].texture);
    //this.hero = new PIXI.Sprite();
    this.hero = new Hero(PIXI.utils.TextureCache["hero.png"], window.innerWidth / 2, this.renderer.height)
    this.actionStage.addChild(this.hero);
  }


  render()
  {
    let boundingBox = this.canvasContainer.getBoundingClientRect();
    if(boundingBox.bottom < 0 || boundingBox.top > window.innerHeight)
      return;

    this.hero.update();
    this.aliensContainer.update();

    for(let x in this.bullets)
    {
      let bullet = this.bullets[x];
      bullet.update();

      if(bullet.y < 0)
      {
        this.actionStage.removeChild(bullet);
        bullet.destroy();
        delete this.bullets[x];
      }
      else {
        //let bulletXInContainer = this.aliensContainer.toAlienPositionX(bullet.x);
        //let bulletYIncontainer = this.aliensContainer.toAlienPositionY(bullet.y);
        //console.log(bullet.x, bullet.y, bulletXInContainer, bulletYIncontainer);

        var alienPosition = this.aliensContainer.wouldHitSomething(bullet.x, bullet.y);
        //console.log(alienPosition, this.aliens);
        if(alienPosition != null && this.aliens[alienPosition] != null)
        {
          let alien = this.aliens[alienPosition];

          this.aliensContainer.addChild(new Explosion(alien, this.returnAlien.bind(this)));

          this.aliensContainer.removeChild(alien);
          delete this.aliens[alienPosition];
          //alien.destroy();

          this.actionStage.removeChild(bullet);
          bullet.destroy();
          delete this.bullets[x];
        }
      }
    }

    this.lastBulletTime += PIXI.ticker.shared.elapsedMS;
    CRT.time += PIXI.ticker.shared.elapsedMS;
    if(this.lastBulletTime > Bullet.BULLET_DELAY)
    {
      this.lastBulletTime = 0;
      this.addBullet();
    }
    try {
      this.renderer.render(this.stage);
    } catch (e) {

    }
    
  }
}

class Invaders extends Component
{
  componentDidMount()
  {
      //Setup PIXI Canvas in componentDidMount
      this.game = new InvadersGame(this.refs.invadersCanvas);
   }

  render()
  {
    return (
      <div className="backgroundCanvas" id="backgroundInvaders" ref="invadersCanvas"></div>
    )
  }
}

export default Invaders;



// WEBPACK FOOTER //
// ./src/backgrounds/Invaders.js